<script lang="ts">
  import { Image } from "sveltestrap";
  let imgPath:string = "/assets/images/user"

</script>
<div class="media">
  <div class="media-size-email">
    <Image class="me-3 rounded-circle" src="{imgPath}/user.png" alt="" />
  </div>
  <div class="media-body">
    <h6 class="f-w-600">{'MARK JENCO'}</h6>
    <p>{'Markjecno@gmail.com'}</p>
  </div>
</div>